// Social apps that open links in their own browser, which often can't reach the camera. Matched by
// app name only: a WebView without one may be a company's own app, and that has to keep working.
// The tokens follow ua-parser-js 1.0.41, the parser react-device-detect ships. Messenger carries
// Facebook's `FBAV` token too, so it has to be tried first.
const IN_APP_BROWSERS = [
    ['messenger', /FBAN\/Messenger|FB_IAB\/(?:Orca-Android|MESSENGER)/i],
    ['facebook', /FBAN\/FBIOS|FB_IAB\/FB4A|;FBAV\//i],
    ['instagram', /\bInstagram[ /][\d.]/i],
    ['tiktok', /musical_ly|BytedanceWebview/i],
    ['snapchat', /\bSnapchat\/[\d.]/i],
    ['linkedin', /\[LinkedInApp\]/i],
    ['x', /TwitterAndroid|Twitter for iP(?:hone|ad)/i],
    ['wechat', /MicroMessenger\//i],
    ['line', /Safari Line\/|\bLine\/[\d.]+\/IAB/i],
];

/** The app whose built-in browser opened the page, or null for any other browser. */
export const getInAppBrowser = (userAgent = globalThis.navigator?.userAgent) => {
    if (!userAgent) return null;

    const match = IN_APP_BROWSERS.find(([, pattern]) => pattern.test(userAgent));

    return match ? match[0] : null;
};
